import { IntegrationName } from "@/models";
import { API_BASE_URL } from "../urls.api";

export const GET_ALL_ROOM_METHOD = "GET";
export const GET_ALL_ROOM_URL = `${API_BASE_URL}/rooms`;

export const GET_BY_OWNER_ROOM_METHOD = "GET";
export const GET_BY_OWNER_ROOM_URL = `${API_BASE_URL}/rooms/owner/id`;
export const GET_BY_OWNER_ROOM_WITH_LICENSE_URL = `${API_BASE_URL}/rooms/license/owner/id`;

export const GET_ROOM_METHOD = "GET";
export const GET_ROOM_URL = `${API_BASE_URL}/rooms`;

export const CREATE_ROOM_METHOD = "POST";
export const CREATE_ROOM_URL = `${API_BASE_URL}/rooms`;

export const UPDATE_ROOM_METHOD = "PUT";
export const UPDATE_ROOM_URL = `${API_BASE_URL}/rooms`;

export const DELETE_ROOM_METHOD = "DELETE";
export const DELETE_ROOM_URL = `${API_BASE_URL}/rooms/:id`;

export const GET_PAGINATED_ROOMS = `${API_BASE_URL}/rooms`;

export const getRoomUsedLicensesUrl = (userId?: string) =>
  `${API_BASE_URL}/rooms/user/used-licenses${userId ? `?userId=${userId}` : ""}`;

export const getUpdateRoomSettingsUrl = (roomId: string) =>
  `${API_BASE_URL}/rooms/${roomId}/settings`;

export const getUpdateRoomSettingsAlertSchedulesUrl = (roomId: string) =>
  `${API_BASE_URL}/rooms/${roomId}/settings/alert-schedules`;

export const getCopyAlertSchedulesToOwnerRoomsUrl = (roomId: string) =>
  `${API_BASE_URL}/rooms/${roomId}/settings/alert-schedules/copy`;

export const getByOwnerIdRoomsUrl = (ownerId?: string) =>
  `${GET_BY_OWNER_ROOM_URL}${ownerId ? `?ownerId=${ownerId}` : ""}`;

export const getByOwnerIdRoomsWithLicenseUrl = (ownerId?: string) =>
  `${GET_BY_OWNER_ROOM_WITH_LICENSE_URL}${ownerId ? `?ownerId=${ownerId}` : ""}`;

export const getRoomsByUserIdUrl = (userId: string) => `${API_BASE_URL}/rooms/by-user/${userId}`;

export const getUpdateRoomByMonitorIdUrl = (monitorId: string) =>
  `${API_BASE_URL}/rooms/monitor/${monitorId}`;

export const mergeRoomUrl = (sourceRoomId: string) => `${API_BASE_URL}/rooms/${sourceRoomId}/merge`;

export const markOwnerRoomsMergeDoneUrl = (ownerId: string) =>
  `${API_BASE_URL}/rooms/owners/${ownerId}/merge-done`;

export const getRoomsWithoutIntegrationUrl = (ownerId: string, integrationType: IntegrationName) =>
  `${API_BASE_URL}/rooms/owner/${ownerId}/without-integration/${integrationType}`;

export const getRoomsWithIntegrationsUrl = (ownerId?: string) =>
  `${API_BASE_URL}/rooms/owner/integrations${ownerId ? `?ownerId=${ownerId}` : ""}`;

export const addDeviceToRoomUrl = (roomId: string) => `${API_BASE_URL}/rooms/${roomId}/devices`;

export const moveDeviceUrl = (roomId: string, monitorId: string) =>
  `${API_BASE_URL}/rooms/${roomId}/devices/${monitorId}/move`;

export const swapDeviceUrl = (roomId: string) => `${API_BASE_URL}/rooms/${roomId}/devices/swap`;

export const getDevicesByRoomUrl = (roomId: string) =>
  `${API_BASE_URL}/rooms/devices/room/${roomId}`;
